var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.facet.name
    ? _c("div", { staticClass: "p-3 bg-white border-bottom" }, [
        _c("div", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.facetName))]),
        _vm._v(" "),
        _vm.facet.type === "price"
          ? _c("div", [_c("item-filter-price")], 1)
          : _vm.facet.cssClass === "has-pictures"
          ? _c(
              "div",
              {
                staticClass: "row flex-wrap text-center mx-n1",
                class: {
                  "row-cols-3": _vm.facets.length >= 3,
                  "row-cols-2": _vm.facets.length < 3,
                },
              },
              _vm._l(_vm.facets, function (value) {
                return _c(
                  "div",
                  { key: value.id, staticClass: "col my-1 px-1" },
                  [
                    _c("input", {
                      staticClass: "form-check-input d-none",
                      attrs: {
                        id: "option-" + value.id + "-" + _vm._uid,
                        type: "checkbox",
                        disabled: _vm.isLoading || value.count <= 0,
                      },
                      domProps: { checked: _vm.isSelected(value.id) },
                      on: {
                        change: function ($event) {
                          return _vm.updateFacet(value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label border rounded-lg p-0",
                        class: [
                          _vm.paddingClasses,
                          _vm.isSelected(value.id) ? "bg-appearance" : "",
                          "option-" + value.id,
                        ],
                        style: _vm.paddingInlineStyles,
                        attrs: { for: "option-" + value.id + "-" + _vm._uid },
                      },
                      [
                        _c("figure", { staticClass: "figure m-0" }, [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              alt: value.name,
                              src:
                                "https://cdn02.plentymarkets.com/dqaqtvmxowl5/frontend/facetten/" +
                                _vm.facet.id +
                                "/" +
                                value.id +
                                ".webp",
                              title: value.name,
                              decoding: "async",
                              loading: "lazy",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "figcaption",
                            { staticClass: "figure-caption text-center mt-2" },
                            [_vm._v(_vm._s(value.name))]
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _c(
              "div",
              { staticClass: "d-flex flex-wrap text-center mx-n1" },
              _vm._l(_vm.facets, function (value) {
                return _c(
                  "div",
                  { key: value.id, staticClass: "my-1 px-1 flex-grow-1" },
                  [
                    _c("input", {
                      staticClass: "form-check-input d-none",
                      attrs: {
                        id: "option-" + value.id + "-" + _vm._uid,
                        type: "checkbox",
                        disabled: _vm.isLoading || value.count <= 0,
                      },
                      domProps: { checked: _vm.isSelected(value.id) },
                      on: {
                        change: function ($event) {
                          return _vm.updateFacet(value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label border rounded-lg px-0",
                        class: [
                          _vm.paddingClasses,
                          _vm.isSelected(value.id) ? "bg-appearance" : "",
                          "option-" + value.id,
                        ],
                        style: _vm.paddingInlineStyles,
                        attrs: { for: "option-" + value.id + "-" + _vm._uid },
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("span", { staticClass: "flex-grow-1" }, [
                            _vm._v(_vm._s(value.name)),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }